let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4bt3q")).then(() => parcelRequire('7jeSP'));